/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// SEO
import SEO from "components/SEO/SEO";

// core components
import GeneNavbar from "components/Navbars/GeneNavbar.js";
import GeneHeader from "components/Headers/GeneHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";

import {
  ServicesSection,
  TeamSection,
  ContactSection,
} from "./LandingSections";

function LandingPage() {
  // Where a visit to this page begins — the top, the reader's last position, or
  // the section named in the URL — is settled by <ScrollRestoration> in
  // routes.js, for every page at once. The `#contact` clearance under the fixed
  // navbar is `scroll-margin-top` in the stylesheet.
  React.useEffect(() => {
    document.documentElement.classList.remove("nav-open");
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  }, []);
  return (
    <>
      <SEO 
        title="Genetic Counselling Services"
        description="Expert genetic counselling services helping families understand hereditary conditions, make informed health decisions, and plan for a healthy future."
        keywords="genetic counselling, genetic testing, hereditary conditions, family health planning, cancer genetics, prenatal testing"
        ogTitle="GeneFlou Genetic Counselling - Professional Genetic Services"
        ogDescription="Compassionate genetic counselling services to help families understand hereditary conditions and make informed health decisions."
      />
      <GeneNavbar />
      <div className="landing-page">
        <GeneHeader />
        <div className="main">
          <ServicesSection />
          <TeamSection />
          <ContactSection />
        </div>
      </div>
      <DemoFooter />
    </>
  );
}

export default LandingPage;
